// 图片上传组件支持的文件列表
export var acceptList = [
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
    'image/bmp',
];
